<template>
    <div class="input-group">
        <input type="number" class="form-control" @change="change" v-model.number="amount">
        <div class="input-group-append">
            <!-- <span class="input-group-text" id="basic-addon2">{{data.TotalFileSizeLimit}} Mb</span> -->
            <select v-model="unit" @change="change" class="form-control">
                <option v-for="u in units" :key="u">{{u}}</option>
            </select>
        </div>
    </div>
</template>
<script>

export default{
    props: ['value']
    ,
    data(){
        return {
            units: ['B', 'Kb', 'Mb', 'Gb'],
            amount: 0,
            unit: 'B'
        }
    },
    methods: {
        change(){
            //var byte = this.amount * (this.units.indexOf(this.unit) * 1024);
            var byte = this.amount;

            if(byte == null || byte == '' || isNaN(byte))
                this.$emit('input', null);

            for(var i = 0; i < this.units.indexOf(this.unit); i++) {
                byte = byte * 1024;
            }

            this.$emit('input', byte);
        }
    },
    watch: {
        value(num){
            if(num != 0 && (!num || isNaN(num))) {
                this.amount = null;
                this.unit = '';
                return;
            }

            var exponent;
            var neg = num < 0;
            var units = ['B', 'Kb', 'Mb', 'Gb', 'Tb', 'Pb', 'Eb', 'Zb', 'Yb'];

            if (neg) {
                num = -num;
            }

            if (num < 1) {
                return (neg ? '-' : '') + num + ' B';
            }

            exponent = Math.min(Math.floor(Math.log(num) / Math.log(1024)), units.length - 1);
            this.amount = (num / Math.pow(1024, exponent)).toFixed(2) * 1;
            this.unit = units[exponent];
        }
    }
}
</script>
